import { render, staticRenderFns } from "./SearchSidebar.vue?vue&type=template&id=bc0551b2"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"
import style0 from "./SearchSidebar.vue?vue&type=style&index=0&id=bc0551b2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports